import React from "react";
import "./Subtitle.scss";

function Subtitle(props) {
    const {text, margin} = props;
  return (
    <div className="subtitle-container">
        <p className={`subtitle-${margin}`}>{text}</p>
    </div>
  );
}

export default Subtitle;
